import React from 'react';

const PenPaper: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M71.108 60.767L117 87.543l-59.483 34.514-45.91-25.988 24.21-14.381"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M87.396 18.498c-5.034-2.876-7.56-4.314-12.594-7.19-2.182-1.25-3.488.359-3.488.359-6.22 9.621-16.117 27.615-23.247 43.16-7.972 17.326-5.618 21.554-5.618 21.554-.567 1.61-1.478 4.897.171 5.821 1.633.925 3.986-1.455 5.086-2.773 0 0 4.914-.206 16.082-16.179 9.845-14.056 19.33-30.217 25.068-41.585.516-1.01-.189-2.465-1.46-3.184v.017z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M63.874 10.262a173.836 173.836 0 00-14.707 25.612"
    ></path>
    <path
      stroke="#fff"
      strokeWidth="3"
      d="M48.068 54.825l15.722 8.423m22.714-45.265l3.42-5.975c.411-.702-.104-1.764-1.135-2.363L81.762 5.64c-1.031-.6-2.217-.496-2.612.223l-3.436 5.957"
    ></path>
  </svg>
);

export default PenPaper;
